import { type CanvasElementFrom, type PartialPropsOf } from '@blaze-runtime/engine-domain';

import {
  getSourceProps,
  getSourceTransforms,
} from '../../canvas-elements/element-model/transformations';
import { parkedToggleButtonProps } from '../toggle-button/toggle-button.transforms';

type ButtonElement = CanvasElementFrom<'button'>;
type ButtonProps = PartialPropsOf<'button'>;

function transformToggleButtonToButton(source: CanvasElementFrom<'toggleButton'>): ButtonElement {
  const props = getSourceProps(source);
  const propsT = getSourceTransforms<'toggleButton', 'button'>(source, 'button');
  const enabledContent = props.content?.toggle?.enabled;
  const enabledStyle = props.style?.states?.enabled;
  const newProps: ButtonProps = {
    content: {
      button: {
        label: enabledContent?.label,
        icon: enabledContent?.icon,
        iconPosition: enabledContent?.iconPosition,
        showLoader: propsT?.content?.button?.showLoader,
      },
      action: propsT?.content?.action,
    },
    style: {
      label: enabledStyle?.label,
      font: enabledStyle?.font,
      button: {
        offset: props.style?.button?.offset,
        fill: enabledStyle?.background?.fill,
        outline: enabledStyle?.background?.outline,
        outlineWidth: enabledStyle?.background?.outlineWidth,
        radius: enabledStyle?.background?.radius,
        visualEffect: propsT?.style?.button?.visualEffect,
      },
    },
    transforms: {
      toggleButton: parkedToggleButtonProps(props),
    },
  };

  return { props: newProps } as unknown as ButtonElement;
}

export const transformToButton = {
  transformToggleButtonToButton,
};
